import { AnnouncementActionConst } from "../Constants/AnnouncementConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { handleAuthError } from "../../utils/authUtils";

const buildHeaders = () => {
  const token = localStorage.getItem("accessToken");
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${token}`);
  return headers;
};

export const FetchAllAnnouncementsAction = () => {
  return async (dispatch) => {
    dispatch({ type: AnnouncementActionConst.FETCH_ALL_ANNOUNCEMENTS_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.ANNOUNCEMENTS}`, {
      method: "GET",
      headers: buildHeaders(),
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: AnnouncementActionConst.FETCH_ALL_ANNOUNCEMENTS_SUCC, result });
        } else {
          dispatch({ type: AnnouncementActionConst.FETCH_ALL_ANNOUNCEMENTS_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AnnouncementActionConst.FETCH_ALL_ANNOUNCEMENTS_FAIL,
          result: { statusCode: 500, data: [], message: error.message || "Network error" },
        });
      });
  };
};

export const FetchAnnouncementDetailAction = (id) => {
  return async (dispatch) => {
    dispatch({ type: AnnouncementActionConst.FETCH_ANNOUNCEMENT_DETAIL_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.ANNOUNCEMENT_DETAIL(id)}`, {
      method: "GET",
      headers: buildHeaders(),
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: AnnouncementActionConst.FETCH_ANNOUNCEMENT_DETAIL_SUCC, result });
        } else {
          dispatch({ type: AnnouncementActionConst.FETCH_ANNOUNCEMENT_DETAIL_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AnnouncementActionConst.FETCH_ANNOUNCEMENT_DETAIL_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error" },
        });
      });
  };
};

export const CreateAnnouncementAction = (data) => {
  return async (dispatch) => {
    dispatch({ type: AnnouncementActionConst.CREATE_ANNOUNCEMENT_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.CREATE_ANNOUNCEMENT}`, {
      method: "POST",
      headers: buildHeaders(),
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (response.ok && (result.statusCode === 200 || result.statusCode === 201)) {
          dispatch({ type: AnnouncementActionConst.CREATE_ANNOUNCEMENT_SUCC, result });
        } else {
          dispatch({ type: AnnouncementActionConst.CREATE_ANNOUNCEMENT_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AnnouncementActionConst.CREATE_ANNOUNCEMENT_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error" },
        });
      });
  };
};

export const UpdateAnnouncementAction = (id, updateData) => {
  return async (dispatch) => {
    dispatch({ type: AnnouncementActionConst.UPDATE_ANNOUNCEMENT_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.UPDATE_ANNOUNCEMENT(id)}`, {
      method: "PATCH",
      headers: buildHeaders(),
      body: JSON.stringify(updateData),
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (response.ok && (result.statusCode === 200 || result.statusCode === 201)) {
          dispatch({ type: AnnouncementActionConst.UPDATE_ANNOUNCEMENT_SUCC, result, id });
        } else {
          dispatch({ type: AnnouncementActionConst.UPDATE_ANNOUNCEMENT_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AnnouncementActionConst.UPDATE_ANNOUNCEMENT_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error" },
        });
      });
  };
};

export const RemoveAnnouncementAction = (id) => {
  return async (dispatch) => {
    dispatch({ type: AnnouncementActionConst.REMOVE_ANNOUNCEMENT_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.REMOVE_ANNOUNCEMENT(id)}`, {
      method: "DELETE",
      headers: buildHeaders(),
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: AnnouncementActionConst.REMOVE_ANNOUNCEMENT_SUCC, result, id });
        } else {
          dispatch({ type: AnnouncementActionConst.REMOVE_ANNOUNCEMENT_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: AnnouncementActionConst.REMOVE_ANNOUNCEMENT_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error" },
        });
      });
  };
};
